import React from "react";

const DockLeftIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill={"currentColor"}
    viewBox={"0 0 24 24"}
    {...props}
  >
    {/* Boxicons v3.0.8 https://boxicons.com | License  https://docs.boxicons.com/free */}
    <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2M5 19V5h3v14zm5 0V5h9v14z"></path>
  </svg>
);

export default DockLeftIcon;
